export const templateSushi = {

config:{
cor_primaria:"#111"
},

elementos:[

{
id:1,
tipo:"texto",
conteudo:"SUSHI HOUSE",
pos_x:80,
pos_y:40,
estilo:{fontSize:30,color:"#e74c3c"}
},

{
id:2,
tipo:"texto",
conteudo:"COMBINADO 20 PEÇAS",
pos_x:30,
pos_y:180,
estilo:{fontSize:16,color:"#fff"}
},

{
id:3,
tipo:"texto",
conteudo:"R$ 59",
pos_x:260,
pos_y:180,
estilo:{fontSize:16,color:"#e74c3c"}
}

]

};